
import { Component, ModelSync, Prop, Vue } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import AddButton from "../buttons/AddButton.vue";
import EditFrame from "../EditFrame.vue";
import { getDeviceTypes } from "@/api/stations";

type SelectItem = { text: string; value: string };

@Component({
  components: {
    EditFrame,
    CancelButton,
    AddButton,
  },
})
export default class AddDeviceDialog extends Vue {
  @ModelSync("value", "input")
  show!: boolean;

  @Prop({ default: "Neues Element Hinzufügen?" })
  title!: string;

  @Prop({ default: "Hinzufügen" })
  actionText!: string;

  deviceTypeToCreate = "";

  private deviceTypes: string[] = [];
  private loading = false;

  get deviceTypesSelectItems(): SelectItem[] {
    return this.deviceTypes.map((t) => ({ text: t, value: t }));
  }

  async mounted() {
    await this.loadDeviceTypes();
  }

  private async loadDeviceTypes() {
    this.loading = true;
    try {
      const types = await getDeviceTypes();
      this.deviceTypes = Array.isArray(types) ? types : [];

      if (!this.deviceTypeToCreate && this.deviceTypes.length > 0) {
        this.deviceTypeToCreate = this.deviceTypes[0];
      }
    } catch (err) {
      this.$emit("load-error", err);
      this.deviceTypes = [];
    } finally {
      this.loading = false;
    }
  }

  onCancel() {
    this.show = false;
    this.$emit("cancel");
  }

  onConfirm() {
    this.show = false;
    this.$emit("confirm", this.deviceTypeToCreate);
  }
}
